import { debounce, set } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";

import Breadcrumbs from "../../components/Common/Breadcrumbs";
import CommonSelect from "../../components/Common/Select";
import { formatDateOnly } from "../../helpers/formatDate";
import {  fetchTickets} from "../../store/ticket/actions";
import { createSelector } from "reselect";
import { fetchRoles, getAllUSer } from "../../store/common/actions";
import { ticketsManagement, whatsappMessage } from "../../helpers/backend_helper";
import { toast } from "react-toastify";
import ViewSelectedTicket from "./viewselectedTicket";
import { capitalize, maskIndianPhoneNumber } from "../../helpers/general";
import { hideLoader, showLoader } from "../../helpers/loaderService";
import config from "../../config";

const statuses = [
  "open",
  "in progress",
  "approval pending",
  "assigned",
  "acknowledged",
  "working",
  "resolved",
  "closed",
  "reopen",
];

export default function ViewTicket() {
  const dispatch = useDispatch();
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [whatsappModalOpen, setWhatsappModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [recipientNumbers, setRecipientNumbers] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [searchAddressDescription, setSearchAddressDescription] = useState("");
  const [searchGuard, setSearchGuard] = useState("");
  const [tickedId, setTickedId] = useState("");
  const [assignedUser, setAssignedUser] = useState(null);
  const [currentAssignedUsers, setCurrentAssignedUsers] = useState([]);
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const { tickets = [] } = useSelector((state) => state.ticketReducer || {});
  const [inputValue, setInputValue] = useState("");
  const [whatsappMessage, setWhatsappMessage]=useState("")
   const [userId, setusername] = useState("");
  
    useEffect(() => {
      if (localStorage.getItem("authUser")) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        console.log("obj",obj)
        obj?.userId && setusername(obj.userId);
  
      }
    }, []);

 const { allUsersnvehicle } = useSelector(
      (state) => state.Common || {}
    );
  const commonSelector = createSelector(
    (state) => state.Common,
    (Common) => ({
      roles: Common.roles || [],
    })
  );
  const { roles } = useSelector(commonSelector);
  const debouncedFetchTickets = useCallback(
    debounce((filters) => {
      dispatch(fetchTickets(filters));
    }, 300),
    [dispatch]
  );

  useEffect(() => {
    const channel = new BroadcastChannel("dashboardChannel");
  
    channel.onmessage = (event) => {
      if (event.data === "update_dashboard") {
        dispatch(fetchTickets({ status: "", search: "", limit: 50 }));
      }
    };
  
    return () => {
      channel.close();
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchRoles());
    dispatch(getAllUSer());
    setUsers(allUsersnvehicle);
  }, [dispatch]);

  useEffect(() => {
    
    if (selectedRole) {
      dispatch(getAllUSer());
      const usersByRole = users?.filter((user) => {
        const userRoles = user["regionId#roleId#userId"].split("#");
        return userRoles[1] == selectedRole.value.toString(); // Compare roleId
      });
      setFilteredUsers(usersByRole);
    } else {
      setFilteredUsers(users);
    }
  }, [selectedRole, users]);

  // Set current assigned users when selected ticket changes
  useEffect(() => {
    if (selectedTicket && selectedTicket.assignedUsers) {
      setCurrentAssignedUsers(selectedTicket.assignedUsers);
    } else {
      setCurrentAssignedUsers([]);
    }
  }, [selectedTicket]);

  const groupedTickets = tickets
  .filter((ticket) => ticket.serialId && ticket?.serialId?.toLowerCase()?.includes(tickedId?.toLowerCase()))
  .reduce((acc, ticket) => {
    acc[ticket?.status?.toLowerCase()] = acc[ticket?.status?.toLowerCase()] || [];
    acc[ticket?.status?.toLowerCase()].push(ticket);
    return acc;
    
  }, {});

  const openStatusModal = (ticket) => {
    setSelectedTicket(ticket);
    setStatusModalOpen(true);
  };


  const openAssignModal = (ticket) => {
    setSelectedTicket(ticket);
    setAssignModalOpen(true);
    setAssignedUser(null);
    setSelectedRole(null);
  };

  const openWhatsappModal = (ticket) => {
    setSelectedTicket(ticket);
    // Filter associated users that are in the assignedUsers list
    const associatedGuardWhatsappNumbers = ticket?.associatedUsers
      ?.filter((user) => ticket?.assignedUsers?.includes(user.userId))
      ?.map((user) => user.whatsAppNumber)
      ?.filter((number) => number) // Filter out null/undefined numbers
      ?.join(", "); // Join with comma for display

    // Prefill the input field and recipient numbers
    setInputValue(associatedGuardWhatsappNumbers || "");
    
    const formattedNumbers = (associatedGuardWhatsappNumbers || "")
      .split(",")
      .map((num) => num.trim())
      .filter((num) => num.length > 0)
      .map((num) => (num.startsWith("91") ? num : `91${num}`));
    
    setRecipientNumbers(formattedNumbers);
    setWhatsappModalOpen(true);
  };
    const openDeleteModal = (ticket) => {
    setSelectedTicket(ticket);
    setDeleteModalOpen(true);
  };

  const handleEditTicket = async (ticketId) => {
    const payload = {
      act: "ticket",
      subact: "get",
      info: { ticketId },
    };
    const response = await ticketsManagement(payload);
    if (response?.message) {
      navigate(`/update-ticket?id=${ticketId}`, {
        state: { ticketData: response.data, editable: true },
      });
    }
  };

  const handleStatusChange = async (status) => {
    if (selectedTicket) {
      const capitalizedStatus =
        status.charAt(0).toUpperCase() + status.slice(1);
      const payload = {
        act: "ticket",
        subact: "updateStatus",
        info: { ticketId: selectedTicket.ticketId, status: capitalizedStatus },
      };
      try {
        const response = await ticketsManagement(payload);
        if (response?.message) {
          toast.success(response?.message, {
            position: "top-right",
            autoClose: 3000,
          });
          dispatch(fetchTickets({ status: "", search: "", limit: 50 }));
        }
      } catch (error) {
        toast.error(error.response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
        });
      }

      setStatusModalOpen(false);
    }
  };
  
  // Fixed: Handle adding or updating assigned users
  const assignUserToTicket = async () => {
    if (selectedTicket && assignedUser) {
      // Check if user is already assigned to avoid duplicates
      if (currentAssignedUsers.includes(assignedUser.id)) {
        toast.info("This user is already assigned to the ticket", {
          position: "top-right",
          autoClose: 3000,
        });
        return;
      }
      
      const updatedAssignedUsers = [...currentAssignedUsers, assignedUser.id];
      
      const payload = {
        act: "ticket",
        subact: "assigned",
        info: {
          ticketId: selectedTicket.ticketId,
          assignedTo: updatedAssignedUsers,
        },
      };
      
      try {
        const response = await ticketsManagement(payload);
        if (response?.message) {
          toast.success(response?.message, {
            position: "top-right",
            autoClose: 3000,
          });
          setAssignedUser(null)
          // Update local state to reflect the change
          setCurrentAssignedUsers(updatedAssignedUsers);
          
          // Refresh tickets data
          dispatch(fetchTickets({ status: "", search: "", limit: 50 }));
        }
      } catch (error) {
        toast.error(error.response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
        });
      }

      // Reset selected user after assignment
      setAssignedUser(null);
    }
  };
  
  // New function: Handle removing assigned users
  const removeUser = async (userId) => {
    if (selectedTicket) {
      const updatedAssignedUsers = currentAssignedUsers.filter(
        (id) => id !== userId
      );
      
      const payload = {
        act: "ticket",
        subact: "assigned",
        info: {
          ticketId: selectedTicket.ticketId,
          assignedTo: updatedAssignedUsers,
        },
      };
      
      try {
        const response = await ticketsManagement(payload);
        if (response?.message) {
          toast.success("User unassigned successfully", {
            position: "top-right",
            autoClose: 3000,
          });
          
          // Update local state to reflect the change
          setCurrentAssignedUsers(updatedAssignedUsers);
          
          // Refresh tickets data
          dispatch(fetchTickets({ status: "", search: "", limit: 50 }));
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to unassign user", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    }
  };
  console.log("selectedTicket",selectedTicket)
  
  const whatsappUserToTicket = async () => {
    
    if (selectedTicket && recipientNumbers.length > 0) {
      if(selectedTicket.incidentTypeName.toLowerCase().includes("fire")){
      const payload = {
        act: "whatsapp",
        templateName:"notify_fire_alert",
        phoneNumbers: recipientNumbers,
        params: [`${selectedTicket.compId}`,`${selectedTicket?.oldCompN}`, `${selectedTicket.beatName}`, `${selectedTicket.roundName}`,
           `${selectedTicket.rangeName}`, `${selectedTicket.divisionName}`, `${selectedTicket?.incidentLocation?.lat},${selectedTicket?.incidentLocation?.long}`],
      };
      const payload1 = {
        act: "whatsapp",
          templateName:"location_share_notifications",
        phoneNumbers: recipientNumbers,
        params: [`${selectedTicket?.incidentLocation?.lat},${selectedTicket?.incidentLocation?.long}`],
      };
      try {
        showLoader();
        const response = await fetch(config.REACT_APP_WHATSAPP_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        await fetch(config.REACT_APP_WHATSAPP_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload1),
        });
      
        const data = await response.json();
        if (data?.Result == "OK") {
          hideLoader();
          toast.success("WhatsApp message sent successfully", {
            position: "top-right",
            autoClose: 3000,
          });
          setRecipientNumbers([]);
          setInputValue("");
          setWhatsappMessage("")
        } else {
          hideLoader();
          console.error("Failed to send message:", data);
          toast.error("Failed to send WhatsApp message", {
            position: "top-right",
            autoClose: 3000,
          });
        }
      } catch (error) {
        hideLoader();
        toast.error(error.response?.data?.message || "Failed to send message", {
          position: "top-right",
          autoClose: 3000,
        });
      }}else{
      const payload = {
        act: "whatsapp",
          templateName:"cust_msg",
        phoneNumbers: recipientNumbers,
        params: [whatsappMessage],
      };
      try {
        showLoader();
        const response = await fetch(config.REACT_APP_WHATSAPP_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (data?.Result == "OK") {
          hideLoader();
          toast.success("WhatsApp message sent successfully", {
            position: "top-right",
            autoClose: 3000,
          });
          setRecipientNumbers([]);
          setInputValue("");
          setWhatsappMessage("")
        } else {
          hideLoader();
          console.error("Failed to send message:", data);
          toast.error("Failed to send WhatsApp message", {
            position: "top-right",
            autoClose: 3000,
          });
        }
      } catch (error) {
        hideLoader();
        toast.error(error.response?.data?.message || "Failed to send message", {
          position: "top-right",
          autoClose: 3000,
        });
      }

      }
      
      setWhatsappModalOpen(false);
    }
  };

  const deleteTicket = async (selectedTicket) => {  
      const payload = {
        act: "ticket",
        subact:"delete",
        info: {ticketId:selectedTicket?.ticketId}
       };
   
      try {
        showLoader();
        const response = await ticketsManagement(payload)
        if (response?.message) {
          hideLoader();
          toast.success("Ticket Dleted successfully", {
            position: "top-right",
            autoClose: 3000,
          });
                setDeleteModalOpen(false);
                setSearchGuard("")
                setTickedId("")
                dispatch(fetchTickets({ status: "", search: "", limit: 50 }));


      
        } else {
          hideLoader();
          toast.error("Failed to delete ticket", {
            position: "top-right",
            autoClose: 3000,
          });
        }
      } catch (error) {
        hideLoader();
        toast.error(error.response?.data?.message || "Failed to delete ticket", {
          position: "top-right",
          autoClose: 3000,
        });

      }
      
      setDeleteModalOpen(false);
    
  };

  const handleNotify = async (ticketId) => {
    const payload = {
      act: "ticket",
      subact: "notifyTicket",
      info: { ticketId },
    };
    try {
      const response = await ticketsManagement(payload);
      if (response?.message) {
        toast.success(response?.message, {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error(error.response?.data?.message, {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const getRoleName = (roleId) => {
    const foundRole = roles?.find((role) => role.roleId == roleId);
    return foundRole ? foundRole.role : "Unknown Role";
  };


  // Trigger debounce on search inputs change
  useEffect(() => {
    debouncedFetchTickets({
      status: "",
      search: searchAddressDescription,
      guard: searchGuard,
      limit: 500,
    });

    // Cleanup debounce to prevent memory leaks
    return () => debouncedFetchTickets.cancel();
  }, [searchAddressDescription, searchGuard, debouncedFetchTickets]);

  const filteredUser = selectedTicket?.associatedUsers?.filter((user) => {

    const userRole = roles?.find((role) => role.roleId == user.role); // Find the role name by roleId
    return userRole?.role !== "Admin"; // Exclude Admin role
  });



  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    const formattedNumbers = value
      .split(",") // Split by comma
      .map(num => num.trim()) // Remove extra spaces
      .filter(num => num.length > 0) // Remove empty values
      .map(num => (num.startsWith("91") ? num : `91${num}`)); // Ensure +91 prefix

    setRecipientNumbers(formattedNumbers);
  };
    const handleWhatsappInputChange = (e) => {
    const value = e.target.value;
    setWhatsappMessage(value);
    };


  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Control Room" breadcrumbItem="Manage Ticket" />
      <Card>
        <CardBody>
        <Row className="mb-1">
          <Col md={4}>
            <Input
              type="text"
              placeholder="Search by address or description"
              value={searchAddressDescription}
              onChange={(e) => {
                const value = e.target.value;
                setSearchAddressDescription(value);
                debouncedFetchTickets({
                  status: "",
                  search: value,
                  limit: 500,
                  guard: searchGuard,
                });
              }}
            />
          </Col>
          <Col md={4}>
            <Input
              type="text"
              placeholder="Search by assigned person"
              value={searchGuard}
              onChange={(e) => {
                const value = e.target.value;
                setSearchGuard(value);
                debouncedFetchTickets({
                  status: "",
                  search: searchAddressDescription,
                  limit: 500,
                  guard: value,
                });
              }}
            />
          </Col>
          <Col md={4}>
            <Input
              type="text"
              placeholder="Search by Ticket ID"
              value={tickedId}
              onChange={(e) => {
                const value = e.target.value;
                setTickedId(value)               
              }}
            />
          </Col>
        </Row>
        </CardBody>
        </Card>

        {/* <Row className="mb-3">
          <Col
            md={12}
            className="d-flex justify-content-end align-items-center"
          >
            <div
              style={{
                width: "24px",
                height: "24px",
                background:
                  "linear-gradient(to right, rgb(241, 253, 146), rgba(255, 165, 0, 0.8))",
                boxShadow: "0 2px 8px rgba(255, 165, 0, 0.8)",
                borderRadius: "4px",
                marginRight: "8px",
              }}
            ></div>
            <span
              style={{ fontSize: "14px", fontWeight: "bold", color: "#333" }}
            >
              Assigned tickets awaiting acknowledgement
            </span>
          </Col>
        </Row> */}
        {!tickets.length && <>No ticket found</>}

        <DragDropContext onDragEnd={() => {}}>
          <div
            style={{
              display: "flex",
              overflowX: "auto",
              gap: "12px",
              padding: "12px 0",
              scrollbarWidth: "thin",
              scrollbarColor: "#666 #e0e0e0",
            }}
          >
            {statuses
              .filter((status) => groupedTickets[status]?.length > 0) // Only show groups with tickets
              .map((status) => (
                <div key={status} style={{ flex: "0 0 auto", width: "300px" }}>
                  <Card className="kanban-column">
                    <CardBody>
                      <CardTitle className="kanban-title">
                      {status === "resolved"
              ? `RESOLVED/ APPROVAL PENDING (${groupedTickets[status]?.length})`
              : `${status.toUpperCase()} (${groupedTickets[status]?.length || 0})`}
                      </CardTitle>
                      <Droppable droppableId={status} direction="vertical">
                        {(provided) => (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            className="kanban-ticket-list"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "12px",
                            }}
                          >
                            {groupedTickets[status]?.map((ticket, index) => {
                              const createdTimeDiff = Math.floor(
                                (new Date() - new Date(ticket.updatedAt)) /
                                  (1000 * 60)
                              ); // Difference in minutes

                              const isFireIncident = ticket.incidentTypeName
                                ?.toLowerCase()
                                .includes("fire");
                              const showHighlight =
                                status.toLowerCase() === "assigned" &&
                                createdTimeDiff >= 30;

                              return (
                                <Draggable
                                  key={
                                    ticket.ticketId + ticket.incidentTypeName
                                  }
                                  draggableId={String(ticket.ticketId)}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      className="kanban-card"
                                      style={{
                                        border: "1px solid #ddd",
                                        borderRadius: "8px",
                                        margin: "8px 0",
                                        padding: "16px",
                                        background: showHighlight
                                          ? "linear-gradient(90deg, rgba(255, 183, 77, 0.9), rgba(255, 138, 0, 0.8))" // Orange gradient
                                          : "#ffffff",
                                        boxShadow: showHighlight
                                          ? "0 4px 10px rgba(255, 140, 0, 0.8)"
                                          : "0 2px 5px rgba(0, 0, 0, 0.1)",
                                        position: "relative",
                                        animation: showHighlight
                                          ? "flashOrange 1s infinite alternate"
                                          : "none",
                                      }}
                                    >
                                      {/* Flash Animation */}
                                      <style>
                                        {`
      @keyframes flashOrange {
        0% { background: rgba(255, 235, 205, 0.9); }
        100% { background: rgba(255, 190, 117, 0.8); }
      }
    `}
                                      </style>

                                      {/* Serial ID */}
                                      {ticket?.serialId && (
                                        <p style={{ marginBottom: 2, display: "flex", justifyContent: "space-between" }}>
                                          <span>
                                          <i className="mdi mdi-card-account-details-outline text-secondary"></i>{" "}
                                          {ticket?.serialId} 
                                          </span>
                                          {showHighlight&& <span onClick={()=>handleNotify(ticket.ticketId)}><span class="mdi mdi-bell-ring-outline"></span>
                                          </span>}

                                        </p>
                                                                                 
                                      )}

                                      {/* Incident Title with Fire Effect */}
                                      <h5
                                        className="mb-2"
                                        style={{
                                          background: isFireIncident
                                            ? "linear-gradient(90deg, rgba(255, 69, 0, 0.9), rgba(255, 0, 0, 0.8))"
                                            : "",
                                          color: isFireIncident
                                            ? "white"
                                            : "#333",
                                          padding: "8px 12px",
                                          borderRadius: "4px",
                                          fontWeight: "bold",
                                          textShadow: isFireIncident
                                            ? "1px 1px 3px rgba(0, 0, 0, 0.6)"
                                            : "none",
                                        }}
                                      >
                                        {ticket.incidentTypeName}
                                      </h5>

                                      {/* Assigned User */}
                                      <p style={{ marginBottom: 2 }}>
                                        <i className="mdi mdi-account text-primary"></i>{" "}
                                        {ticket.assignedUser || "Unassigned"}
                                      </p>

                                      {/* Description */}
                                      {ticket.description && (
                                        <p style={{ marginBottom: 2 }}>
                                          <i className="mdi mdi-note-text-outline text-muted"></i>{" "}
                                          {ticket.description}
                                        </p>
                                      )}

                                      {/* Address */}
                                      {ticket.address && (
                                        <p style={{ marginBottom: 2 }}>
                                          <i className="mdi mdi-home-outline text-secondary"></i>{" "}
                                          {ticket.address}
                                        </p>
                                      )}

                                      {/* Creation Time */}
                                      {ticket.createdAt && (
                                        <p style={{ marginBottom: 2 }}>
                                          <i className="mdi mdi-clock-outline text-info"></i>{" "}
                                          {formatDateOnly(ticket.createdAt)}
                                        </p>
                                      )}

                                      {/* Action Buttons */}
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "8px",
                                          marginTop: "8px",
                                        }}
                                      >
                                        <Button
                                          color="primary"
                                          size="sm"
                                          onClick={() =>
                                            openAssignModal(ticket)
                                          }
                                        >
                                          Assign
                                        </Button>
                                        <Button
                                          color="warning"
                                          size="sm"
                                          onClick={() =>
                                            openStatusModal(ticket)
                                          }
                                        >
                                          Status
                                        </Button>
                                        <Button
                                          color="info"
                                          size="sm"
                                          onClick={() =>
                                            handleEditTicket(ticket.ticketId)
                                          }
                                        >
                                          Edit
                                        </Button>
                                        {/* {isFireIncident && ( */}
                                          <Button
                                            color="success"
                                            size="sm"
                                            className="m-0 px-1"
                                            onClick={() =>
                                              openWhatsappModal(ticket)
                                            }
                                          >
                                            <span className="mdi mdi-whatsapp"></span>
                                          </Button>
                                        {/* )}  */}

                                        {config.REACT_APP_ADMINID.includes(userId)  &&
                                          <Button
                                            color="secondary"
                                            size="sm"
                                            className="m-0 px-1"
                                            onClick={() =>
                                              openDeleteModal(ticket)
                                            }
                                          >
                                            <span class="mdi mdi-trash-can-outline"></span>
                                          </Button>}
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              );
                            })}

                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </CardBody>
                  </Card>
                </div>
              ))}
          </div>
        </DragDropContext>

        {/* Status Change Modal */}
        <Modal
          size="lg"
          isOpen={statusModalOpen}
          toggle={() => setStatusModalOpen(false)}
        >
          <ModalHeader toggle={() => setStatusModalOpen(false)}>
            Change Status : {selectedTicket?.serialId}  Status : {selectedTicket?.status}
          </ModalHeader>
          <ModalBody>
            <ViewSelectedTicket data={selectedTicket}/>

            {selectedTicket?.status == "Closed" && selectedTicket?.resolvedByUser && (
              <>
                <Label>Closed By:</Label>{" "}
                <span className="text-capitalize">{selectedTicket?.resolvedByUser}</span>
              </>
            )}
            {selectedTicket?.status == "Reopen" && selectedTicket?.resolvedByUser && (
              <>
                <Label>Reopen By:</Label>{" "}
                <span className="text-capitalize">{selectedTicket?.resolvedByUser}</span>
              </>
            )}
            
            <div>
              {/* Show only if status is NOT Closed AND NOT Assigned */}
              {selectedTicket?.status !== "Closed" && selectedTicket?.status !== "Assigned" && selectedTicket?.status !== "Reopen"  && selectedTicket?.assignedUser && (
                <>
                  <Label>{selectedTicket?.status + " By"}:</Label>{" "}
                  <span className="text-capitalize">{selectedTicket.assignedUser}</span>
                </>
              )}
            
              <br />
            
              {/* Show only if status is NOT Open AND NOT Assigned */}
              {selectedTicket?.status !== "Open"  && selectedTicket?.assignedUser && (
                <>
                  <Label>Assigned To:</Label>{" "}
                  <span className="text-capitalize">{selectedTicket.assignedUser}</span>
                </>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
          <div className="status-options">
              {statuses
                .slice(
                  statuses.indexOf(selectedTicket?.status?.toLowerCase()) + 1
                )
                .filter((status) => status !== "assigned")
                .map((status) => (
                  <Button
                    key={status}
                    color="primary"
                    onClick={() => handleStatusChange(status)}
                    className="mb-2 me-2"
                  >
                    {status.toUpperCase()}
                  </Button>
                ))}
              {selectedTicket?.status?.toLowerCase() ===
                statuses[statuses.length - 1] &&
                statuses.map((status) => (
                  <Button
                    key={status}
                    color="primary"
                    onClick={() => handleStatusChange(status)}
                    className="mb-2 me-2"
                  >
                    {status.toUpperCase()}
                  </Button>
                ))}
            </div>
          </ModalFooter>
        </Modal>
        
        {/* Assign User Modal */}
        <Modal
         size="lg"
          isOpen={assignModalOpen}
          toggle={() => setAssignModalOpen(false)}
        >
          <ModalHeader toggle={() => setAssignModalOpen(false)}>
            Assign Ticket : {selectedTicket?.serialId}
          </ModalHeader>
          <ModalBody>
            <table className="table table-bordered">
              <tbody>
                {/* Ticket Type - Centered */}
                <tr>
                  <td colSpan={5} className="text-center fw-bold">
                    <label className="form-label">Ticket Type:</label>{" "}
                    {selectedTicket?.incidentTypeName}
                    <div>
                      <label className="form-label">Description:</label>{" "}
                      {selectedTicket?.description}
                    </div>
                    {selectedTicket?.createdByUser&&<label>Created By :{"  "} </label>}
                    <span className="text-capitalize">{"  "}{selectedTicket?.createdByUser}</span>

                  </td>
                </tr>
                {/* Division, Range, Round, and Beat in One Row */}
                {selectedTicket?.divisionName && (
                  <tr>
                    <td>
                      <label className="form-label">Division</label>{" "}
                      {selectedTicket?.divisionName}
                    </td>
                    <td>
                      <label className="form-label">Range</label>{" "}
                      {selectedTicket?.rangeName}
                    </td>
                    <td>
                      <label className="form-label">Round</label>{" "}
                      {selectedTicket?.roundName}
                    </td>
                    <td>
                      <label className="form-label">Beat</label>{" "}
                      {selectedTicket?.beatName}
                    </td>
                    <td>
                      <label className="form-label">comp</label>{" "}
                      {selectedTicket?.compId}
                      <br />
                      <label className="form-label"> Old comp</label>{" "}
                      {selectedTicket?.oldCompN??"-"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {filteredUser?.length > 0 && (
              <div className="mb-4">
                <h6 className="mb-2">Associated Users:</h6>
                <table
                  className="table table-bordered table-sm"
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    textAlign: "left",
                    marginBottom: "4px",
                  }}
                >
                  <thead>
                    <tr>
                      <th style={{ padding: "8px", background: "#f4f4f4" }}>First Name</th>
                      <th style={{ padding: "8px", background: "#f4f4f4" }}>Last Name</th>
                      <th style={{ padding: "8px", background: "#f4f4f4" }}>Role</th>
                      <th style={{ padding: "8px", background: "#f4f4f4" }}>Contact</th>

                      
                    </tr>
                  </thead>
                  <tbody>
                    {filteredUser?.map((user, index) => (
                      <tr key={index}>
                        <td style={{ padding: "8px" }}>{user.firstName}</td>
                        <td style={{ padding: "8px" }}>{user.lastName}</td>
                        <td style={{ padding: "8px" }}>{getRoleName(user.role)}</td>
                        <td style={{ padding: "8px" }}>
  <a
    href={`tel:${String(user.contactNumber).replace(/\D/g, "")}`}
    style={{ color: "#1a73e8", textDecoration: "none" }}
  >
    {maskIndianPhoneNumber(String(user.contactNumber))}
  </a>
</td>

                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Currently Assigned Users Section */}
            {currentAssignedUsers && currentAssignedUsers.length > 0 && (
              <div className="mb-4">
                <h6 className="mb-2">Currently Assigned Users:</h6>
                <ul className="list-group">
                {currentAssignedUsers?.map((userId) => {
  const user = allUsersnvehicle?.find(u => u.userId === userId);
  const userName = user ? `${capitalize(user.firstName)} ${capitalize(user.lastName)}` : userId;

  return (
    <li
      key={userId}
      className="list-group-item d-flex justify-content-between align-items-center"
    >
      <span>{userName}</span>
      <Button color="danger" size="sm" onClick={() => removeUser(userId)}>
        <span className="mdi mdi-close"></span>
      </Button>
    </li>
  );
})}

    </ul>
              </div>
            )}

            <div className="mb-3">
              <label className="form-label">Select Role</label>
              <Select
                options={roles?.map((role) => ({
                  value: role.roleId,
                  label: role.role,
                }))}
                onChange={(selectedOption) => {
                  setSelectedRole(selectedOption);
                  setAssignedUser(null); // Reset selected user when role changes
                }}
                placeholder="Select role..."
                isClearable
                value={selectedRole}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Select User</label>
              <CommonSelect
                options={filteredUsers?.map((user) => ({
                  value: user.id,
                  label: user.name?.charAt(0).toUpperCase() + user.name?.slice(1),
                }))}
                role={selectedRole?.value}
                onChange={(selectedOption) =>
                  setAssignedUser({
                    id: selectedOption?.value,
                    name: selectedOption?.label,
                  })
                }
                placeholder="Search and select user..."
                isClearable
                isDisabled={!selectedRole}
                value={assignedUser ? { value: assignedUser.id, label: assignedUser.name } : null}
              />
            </div>
            <Button
              color="primary"
              onClick={assignUserToTicket}
              className="mt-3"
              disabled={!assignedUser}
            >
              Assign User
            </Button>
          </ModalBody>
        </Modal>

        {/* //Whatsapp Modal */}
        <Modal
          isOpen={whatsappModalOpen}
          toggle={() => setWhatsappModalOpen(false)}
        >
          <ModalHeader toggle={() => setWhatsappModalOpen(false)}>
            Message on Whatsapp : {selectedTicket?.serialId}
          </ModalHeader>
          <ModalBody>
          <Input
          type="text"
          className="mb-3"
          placeholder="Enter comma-separated numbers"
          value={inputValue}
          onChange={handleInputChange}
        />
            {![selectedTicket?.incidentTypeName?.toLowerCase()].includes("forest fire") && (
              <Input
                type="textarea"
                placeholder="Enter your message here..."
                value={whatsappMessage}
                onChange={handleWhatsappInputChange}
              />
            )}

            <Button
              color="primary"
              size="sm"
              onClick={whatsappUserToTicket}
              className="mt-3"
              // disabled={!assignedUser}
            >
              Send
            </Button>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={deleteModalOpen}
          toggle={() => setDeleteModalOpen(false)}
        >
          <ModalHeader toggle={() => setDeleteModalOpen(false)}>
           Delete Ticket : {selectedTicket?.serialId}
          </ModalHeader>
          <ModalBody>
          <Label>Are you sure you want to delete {selectedTicket?.serialId} ?</Label>  
          <div>
            </div>         
            <Button
              color="primary"
              size="sm"
              onClick={()=>deleteTicket(selectedTicket)}
              className="mt-3"
              // disabled={!assignedUser}
            >
              Delete
            </Button><Button
              color="secondary"
              size="sm"
              onClick={()=>setDeleteModalOpen(false)}
              className="mt-3 mx-2"
              // disabled={!assignedUser}
            >
              Cancel
            </Button>
          </ModalBody>
        </Modal>
      </Container>
    </div>
  );
}
